<template>
  <div class="product-header">
      <div class="header-content">
          <div class="content-left">
             <ul>
                 <li><router-link to="/county" style="color:#000;" active-class="active">县级医工体</router-link></li>
                 <li><router-link to="/conjoined" style="color:#000" active-class="active">医联体</router-link></li>
                 <li><router-link to="/union" style="color:#000" active-class="active">专科联盟</router-link></li>
                 <li><router-link to="/coordination" style="color:#000" active-class="active">院内协同</router-link></li>
             </ul>
          </div>
          <div class="content-right">
              <router-view></router-view>
          </div>
      </div>
  </div>
  </template>
<script>
    export default {
        
    }
</script>

<style lang="scss">
 .active{
        color: #0E67DF !important;
       
    }
    .product-header{
        width: 100%;
        .header-content{
            width: 1200px;
            margin: 0 auto;
            display: flex;
            .content-left{
                width:10%;
                ul {
                    li{
                        padding-top: 15px;
                    }
                }
            }
            .content-right{
                width: 90%;
                border-left: 1px solid #eee;
                padding-bottom: 25px;

            }
        }
    }
</style>